var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSadCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 280,
    viewBox: "0 0 200 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "2de9352b-6051-48a2-a381-51f3d5164496",
    cx: 122.05,
    cy: 73.75,
    r: 71.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#faee7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#fbe571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fed659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "3018571f-593c-4573-9967-066a0259ca1f",
    cx: 87.87,
    cy: 78.32,
    r: 17.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a94b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#188db2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#14799d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0d5a7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073e5e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "3260763b-6513-449e-8084-4cd24a8ea73a",
    cx: 155.98,
    cy: 78.83,
    r: 17.52,
    xlinkHref: "#3018571f-593c-4573-9967-066a0259ca1f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "82b7d8c4-99ad-44c2-bc2f-589575e051ef",
    cx: 122.05,
    cy: 93.08,
    r: 5.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3837e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#ee7c77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e26964"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconSadCat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "f31b7b3b-b5b9-4b73-8113-5ddfb3532ea7",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b195a9dd-a1a3-494c-97f1-5c3b61299fe4",
    "data-name": "TAIL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.28,247.44c-.12.38-.26.75-.39,1.11-.06.18-.13.37-.2.55l-.2.48c-.08.22-.17.44-.26.67l-.21.48c-.1.22-.2.46-.31.69s-.33.71-.5,1.06c-.5,1-1,2-1.63,3a45.17,45.17,0,0,1-28.74,20.66,47.54,47.54,0,0,1-6.79,1.06c-1.33.11-2.68.17-4,.17H22.47a29.93,29.93,0,0,1-3.83-.25h-.16a20.11,20.11,0,0,1-7.58-1.46C4.64,273.14.28,267.56.28,261.09c0-8.32,7.18-15.15,16.36-16,.61-.05,1.21-.07,1.84-.07a20.15,20.15,0,0,1,5.71.81c.59,0,1.17.09,1.74.15,1,.2,1.94.36,2.94.5a47.47,47.47,0,0,0,6.23.41,45.92,45.92,0,0,0,34.19-15.14,44.31,44.31,0,0,0,4.28-5.55,4.94,4.94,0,0,0,.27-.42c.52-.8,1-1.61,1.47-2.45v0c.07-.1.12-.21.18-.31.5-.91,1-1.84,1.39-2.79.06-.11.1-.21.15-.32s.21-.5.32-.76c.1.2.21.4.32.6.43.8.87,1.58,1.34,2.35.18.32.37.63.56.93s.46.73.69,1.09c.11,1.19.24,2.37.41,3.54.19,1.38.41,2.76.68,4.11A71.61,71.61,0,0,0,86.28,247.44Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.57,264.41v13H22.79v-13a3.39,3.39,0,0,1,6.78,0Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.91,264.41v13H35.13v-13a3.39,3.39,0,1,1,6.78,0Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.84,264.41v11.73a47.54,47.54,0,0,1-6.79,1.06V264.41a3.4,3.4,0,0,1,6.79,0Z",
    style: {
      fill: "#ffce4d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "147a7c64-8137-4ae4-bd60-d4ad01b9cc15",
    "data-name": "T-SHIRT",
    d: "M178.87,170.6l-6.76,3.09-1.13.56-6.92,3.45v.13L164,220.17v7.5H76.56v-10l-.11-39.79v-.13l-6.88-3.43-1.17-.58-6.76-3.09,20.8-29.86,3.26-4.69,1.51,0,.26.09.17.06c2.13.73,4.31,1.4,6.53,2a97.12,97.12,0,0,0,10.59,2.23c4.18.39,8.65.64,13.41.72.45.05.92.09,1.38.12l.7,0,1.4.08h.07c1.18-.05,2.34-.13,3.49-.24,4.76-.08,9.22-.33,13.41-.72a97,97,0,0,0,10.58-2.23c1.28-.34,2.54-.7,3.77-1.09l.77-.24.7-.23h.78l2.84,4.08.62.89Z",
    style: {
      fill: "#ee4123"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "e4c42fca-2322-41d8-a51f-4371a074fc7e",
    "data-name": "PAWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,272.74c0,2.9-4.83,5.25-10.79,5.25-5.27,0-9.66-1.84-10.6-4.26l-.09-.24s0,0,0-.06a5.15,5.15,0,0,1-.09-.8,1.77,1.77,0,0,1,0-.23,1.69,1.69,0,0,1,0-.23,5.67,5.67,0,0,1,.38-1.87s0,0,0-.05a50.26,50.26,0,0,0,1.75-5.7c.26-1.08.5-2.19.7-3.31a51.29,51.29,0,0,0,.57-13.49,41.76,41.76,0,0,1-8.55.88h-.37a43.21,43.21,0,0,1-7.91-.81,50.44,50.44,0,0,0,.51,14c.2,1.12.43,2.22.7,3.31a48.31,48.31,0,0,0,1.75,5.7l0,.05a5.66,5.66,0,0,1,.38,1.86,1.77,1.77,0,0,1,0,.23,1.93,1.93,0,0,1,0,.24,5.29,5.29,0,0,1-.09.8s0,0,0,.05,0,.16-.08.25c-.94,2.42-5.33,4.25-10.6,4.25-5,0-9.21-1.65-10.43-3.89a2.76,2.76,0,0,1-.36-1.35c0-1.92,2.12-3.6,5.29-4.51a15.71,15.71,0,0,1,1.85-.43h.16l0,0c-.73-.57-1.44-1.17-2.13-1.79a56.47,56.47,0,0,1-13.67-19.17,71.61,71.61,0,0,1-4.93-15.66c-.27-1.35-.49-2.73-.68-4.11h81.41c-2.52,17.08-10.46,31.56-21.33,40.12l0,0h.16C145,268.53,148,270.46,148,272.74Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.66,217.9a6.5,6.5,0,0,1-3,5l-.2.1a6.48,6.48,0,0,1-5.55,0,12.09,12.09,0,0,1-3.63-2.38,15.27,15.27,0,0,1-2.37-2.76s0,0,0,0l-.45-.71c-.07-.12-.14-.23-.2-.35l0,0-.48-1c-.27-.59-.55-1.18-.81-1.79v0a70.29,70.29,0,0,1-3-8.29,72.55,72.55,0,0,1-1.88-8.08A76.93,76.93,0,0,1,68.93,185a75.4,75.4,0,0,1,.64-10.49l18.61,9.09-.06.17v0h.26s0,.06,0,.09a52.1,52.1,0,0,0-1,10.19,51.4,51.4,0,0,0,2.18,15l.08.12a16.24,16.24,0,0,1,1.94,5.28A11.29,11.29,0,0,1,91.66,217.9Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.65,183.83a76.93,76.93,0,0,1-1.13,12.63,77.89,77.89,0,0,1-1.88,8.08,70.32,70.32,0,0,1-3,8.29v0c-.26.61-.53,1.2-.81,1.79q-.23.51-.48,1v0c-.07.12-.14.23-.2.35l-.46.71s0,0,0,0a16.11,16.11,0,0,1-2.37,2.76,12.13,12.13,0,0,1-3.64,2.38,6.52,6.52,0,0,1-5.55,0l-.2-.11a6.5,6.5,0,0,1-3-5,12.3,12.3,0,0,1,.11-3.51A16,16,0,0,1,153,208a1.27,1.27,0,0,1,.07-.12,51.4,51.4,0,0,0,2.18-15,52.1,52.1,0,0,0-1-10.19.29.29,0,0,1,0-.09h.26v0l-.05-.17,18.6-9.09A73.89,73.89,0,0,1,173.65,183.83Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "1c60560c-2c2d-4b64-9b2e-79b01fc693a7",
    "data-name": "SHADOWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.7,231.78H81.35a71.61,71.61,0,0,0,4.93,15.66c-.12.38-.26.75-.39,1.11-.06.18-.13.37-.2.55l-.2.48c-.08.22-.17.44-.26.67l-.21.48c-.1.22-.2.46-.31.69s-.33.71-.5,1.06c-.5,1-1,2-1.63,3A59.42,59.42,0,0,1,77.5,239a70,70,0,0,1-.9-11.34h85.56Z",
    style: {
      fill: "#f1b02e",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.37,183.76c-.15.77-.29,1.54-.41,2.32l-18.7-8.82c.08-.94.18-1.86.31-2.79l18.61,9.09-.07.2Z",
    style: {
      fill: "#f1b02e",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,176.14,154.62,185c-.12-.78-.26-1.55-.41-2.32h.26l-.07-.2L173,173.34C173.14,174.27,173.24,175.2,173.32,176.14Z",
    style: {
      fill: "#f1b02e",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.31,221.52a6.77,6.77,0,0,1-3.12,5.28l-.2.11a6.83,6.83,0,0,1-5.83,0,14.66,14.66,0,0,1-6.31-5.39l0,0c-.17-.25-.32-.5-.48-.75l0-.09A12.09,12.09,0,0,0,82.94,223a6.48,6.48,0,0,0,5.55,0l.2-.1a6.5,6.5,0,0,0,3-5,11.29,11.29,0,0,0-.1-3.51,16.24,16.24,0,0,0-1.94-5.28l-.08-.12a51.4,51.4,0,0,1-2.18-15,52.1,52.1,0,0,1,1-10.19l3.3,1.61-.07.21h.27a55.1,55.1,0,0,0-1.06,10.8,53.66,53.66,0,0,0,2.29,15.69l.08.13a17.3,17.3,0,0,1,2,5.54A12.46,12.46,0,0,1,95.31,221.52Z",
    style: {
      fill: "#c42128",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.28,219.53l-.05.09c-.15.26-.32.5-.48.75l0,0a14.63,14.63,0,0,1-6.3,5.39,6.83,6.83,0,0,1-5.83,0,1.39,1.39,0,0,1-.21-.11,6.81,6.81,0,0,1-3.13-5.28,12.5,12.5,0,0,1,.12-3.69,16.84,16.84,0,0,1,2-5.54l.07-.14a53.54,53.54,0,0,0,2.3-15.68,54.34,54.34,0,0,0-1.07-10.8H151l-.08-.21,3.31-1.61a52.1,52.1,0,0,1,1,10.19,51.4,51.4,0,0,1-2.18,15,1.27,1.27,0,0,0-.07.12,16,16,0,0,0-1.95,5.28,12.3,12.3,0,0,0-.11,3.51,6.5,6.5,0,0,0,3,5l.2.11a6.52,6.52,0,0,0,5.55,0A12.13,12.13,0,0,0,163.28,219.53Z",
    style: {
      fill: "#c42128",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.69,141.63a99.45,99.45,0,0,1-20.06,5.29c-4.19.39-8.65.63-13.41.72-1.15.1-2.31.19-3.49.24h-.07c-1.18,0-2.34-.14-3.48-.24q-7.14-.13-13.41-.72a97.12,97.12,0,0,1-10.59-2.23,95,95,0,0,1-11.73-3.95l3.26-4.69,1.51,0,.43.15c2.13.73,4.31,1.4,6.53,2a97.12,97.12,0,0,0,10.59,2.23c4.18.39,8.65.64,13.41.72.45.05.92.08,1.38.12l.7,0,1.4.08h.07c1.18-.05,2.34-.13,3.49-.24,4.76-.08,9.22-.33,13.41-.72a97,97,0,0,0,10.58-2.23c1.55-.41,3.06-.85,4.54-1.33l.7-.23h.78l2.84,4.08Z",
    style: {
      fill: "#c42128",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "0c96fa04-fa4c-4945-bcb4-81a2aac8f62a",
    "data-name": "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    id: "0e34d334-2db6-4a04-a210-fe17d005c6dc",
    "data-name": "HEAD",
    d: "M192.91,109.76c-7.09,12-23.1,23-43.34,28.45A97.12,97.12,0,0,1,139,140.44l-3,.25q-5,.38-10.43.47c-1.15.11-2.31.19-3.49.24H122c-1.18-.05-2.34-.13-3.49-.24-3.12,0-6.12-.18-9-.37-1.51-.1-3-.21-4.41-.35a97.12,97.12,0,0,1-10.59-2.23c-20.24-5.42-36.25-16.47-43.35-28.45C48,104.32,46.6,98.69,47.49,93.3c.1-.62.24-1.24.4-1.86A20.56,20.56,0,0,1,49.17,88a21.72,21.72,0,0,0,1.37-2.39,19.69,19.69,0,0,0,1.27-3.44,19.15,19.15,0,0,0,.66-5.52c0-.47,0-1-.07-1.42,0-.83-.07-1.67-.08-2.51a94,94,0,0,1,2.89-25.83,67,67,0,0,1,26-30,71.74,71.74,0,0,1,24-9.21q3.33-.65,6.79-1c2-.22,4.08-.39,6.17-.48q1.93-.07,3.9-.09c1,0,1.93,0,2.89.06q2.91.09,5.75.36c2.31.22,4.57.52,6.79.92a72.13,72.13,0,0,1,25.46,9.47,67,67,0,0,1,26,30,94.43,94.43,0,0,1,2.89,25.83c0,.84,0,1.68-.08,2.51,0,.47-.07,1-.07,1.42a19.15,19.15,0,0,0,.66,5.52,19.69,19.69,0,0,0,1.27,3.44A20.22,20.22,0,0,0,194.94,88a19.69,19.69,0,0,1,1.27,3.44,17.7,17.7,0,0,1,.41,1.86C197.51,98.69,196.13,104.32,192.91,109.76Z",
    style: {
      fill: "url(#2de9352b-6051-48a2-a381-51f3d5164496)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "89044e81-a0b2-40ce-a984-2cc7c2955639",
    "data-name": "SHADOW",
    d: "M192.91,109.76c-7.09,12-23.1,23-43.34,28.45A97.12,97.12,0,0,1,139,140.44c-4.18.39-8.65.64-13.4.72-1.15.11-2.31.19-3.49.24H122c-1.18-.05-2.34-.13-3.49-.24-4.75-.08-9.22-.33-13.4-.72a97.12,97.12,0,0,1-10.59-2.23c-20.24-5.42-36.25-16.47-43.35-28.45-2.91-4.93-4.32-10-3.89-15,0,.32.06.63.1.94a27.76,27.76,0,0,0,3.79,10.51c7.1,12,23.11,23,43.35,28.46a99.46,99.46,0,0,0,10.59,2.22q6.27.59,13.4.73c1.15.1,2.31.18,3.49.24h.07c1.18-.06,2.34-.14,3.49-.24q7.13-.13,13.4-.73a99.46,99.46,0,0,0,10.59-2.22c20.24-5.43,36.25-16.47,43.34-28.46a27.62,27.62,0,0,0,3.8-10.51c0-.31.07-.62.1-.94C197.24,99.74,195.83,104.83,192.91,109.76Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,6.66v11a3.4,3.4,0,1,1-6.79,0V7.69Q108.52,7,112,6.66Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.94,6.15V19.5a3.4,3.4,0,0,1-6.79,0V6.18q1.93-.07,3.9-.09C123,6.1,124,6.11,124.94,6.15Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.48,7.43V17.64a3.4,3.4,0,1,1-6.79,0V6.51C133,6.73,135.26,7,137.48,7.43Z",
    style: {
      fill: "#f4c54a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "047708cd-9ef8-40aa-85df-cab70e1e054d",
    "data-name": "EYES"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.54,80.89a21.71,21.71,0,1,1-21.7-21.56A21.65,21.65,0,0,1,108.54,80.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46,78.32A17.6,17.6,0,1,1,87.87,60.87,17.52,17.52,0,0,1,105.46,78.32Z",
    style: {
      fill: "url(#3018571f-593c-4573-9967-066a0259ca1f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.87,96.8a18.48,18.48,0,1,1,18.62-18.48A18.58,18.58,0,0,1,87.87,96.8Zm0-34.91a16.43,16.43,0,1,0,16.56,16.43A16.52,16.52,0,0,0,87.87,61.89Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.27,73.27A11.69,11.69,0,1,1,90.58,61.58,11.69,11.69,0,0,1,102.27,73.27Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49,73.44a1.78,1.78,0,1,1-1.77-1.77A1.78,1.78,0,0,1,81.49,73.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,65.74a3.75,3.75,0,1,0,3.74-3.9A3.82,3.82,0,0,0,81,65.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,81.14a21.45,21.45,0,1,1-21.45-21.3A21.4,21.4,0,0,1,179,81.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.58,78.83A17.6,17.6,0,1,1,156,61.38,17.52,17.52,0,0,1,173.58,78.83Z",
    style: {
      fill: "url(#3260763b-6513-449e-8084-4cd24a8ea73a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,97.31a18.48,18.48,0,1,1,18.63-18.48A18.58,18.58,0,0,1,156,97.31Zm0-34.9a16.43,16.43,0,1,0,16.57,16.42A16.51,16.51,0,0,0,156,62.41Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.47,74a11.69,11.69,0,1,1-11.68-11.69A11.68,11.68,0,0,1,164.47,74Z",
    style: {
      fill: "#073e5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.75,70.61A1.78,1.78,0,1,1,163,68.84,1.78,1.78,0,0,1,164.75,70.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,66.5a3.75,3.75,0,1,0,3.74-3.9A3.82,3.82,0,0,0,151,66.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "46da259b-97da-4f3c-a42b-a0b176efad5e",
    "data-name": "MOUTH",
    d: "M135.94,119.2a14.72,14.72,0,0,1-.13,1.88,13.83,13.83,0,0,0-27.51,0,14.72,14.72,0,0,1-.13-1.88,13.89,13.89,0,1,1,27.77,0Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "c865a0e4-f3f7-435f-8131-0b9c62943534",
    "data-name": "EYEBROWS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.37,42.67c.28,1.94-2.69,5.65-7.2,8.8-4.25,3-8.5,4.51-10.41,3.89a1.51,1.51,0,0,1-.81-.55c-1.17-1.68,2-5.89,7-9.41s10-5,11.22-3.33A1.21,1.21,0,0,1,109.37,42.67Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.74,42.67c-.28,1.94,2.69,5.65,7.2,8.8,4.24,3,8.49,4.51,10.41,3.89a1.59,1.59,0,0,0,.81-.55c1.17-1.68-1.95-5.89-7-9.41s-10-5-11.22-3.33A1.21,1.21,0,0,0,134.74,42.67Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "95ca791b-40e0-4606-bb3a-472889ca6025",
    "data-name": "NOSE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.46,93.08c0,2.16-3.32,3.9-7.41,3.9s-7.4-1.74-7.4-3.9,3.32-3.91,7.4-3.91S129.46,90.92,129.46,93.08Z",
    style: {
      fill: "url(#82b7d8c4-99ad-44c2-bc2f-589575e051ef)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.58,91.43c0,.68-.88,1.24-2,1.24s-2-.56-2-1.24.88-1.23,2-1.23S126.58,90.75,126.58,91.43Z",
    style: {
      fill: "#facac2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "5b00a618-78b1-4da4-8bde-f71b2f91596b",
    "data-name": "EARS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7,12.45q-3.58,2.21-7.17,4.72l-.67.47a96.34,96.34,0,0,0-9.59,7.78q-2.47,2.28-4.7,4.68a74.84,74.84,0,0,0-14,21.19,45.79,45.79,0,0,1-1.4-6.43A52.34,52.34,0,0,1,62.81,7.22c.19-.28.39-.55.6-.83.7-.93,1.43-1.86,2.2-2.76a2.09,2.09,0,0,1,.22-.16,7,7,0,0,1,3.84-1.28h0c1.23.26,2.46.57,3.67.94A47,47,0,0,1,86.47,9.25l.06,0A42.3,42.3,0,0,1,90.7,12.45Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27,25.42q-2.47,2.28-4.7,4.68a74.84,74.84,0,0,0-14,21.19,45.79,45.79,0,0,1-1.4-6.43A52.34,52.34,0,0,1,62.81,7.22C68.37,10.61,72.41,17.38,73.27,25.42Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.41,12.06c2.39,1.46,4.78,3,7.17,4.72a92.61,92.61,0,0,1,14.95,12.93,74.6,74.6,0,0,1,14,21.19c4.37-14.9,1-31.59-8.82-44.9-.7-.93-1.43-1.86-2.2-2.76l-.22-.17a7,7,0,0,0-3.85-1.27s0,0,0,0c-1.24.26-2.47.57-3.68.93a47.39,47.39,0,0,0-13.1,6.13l-.07,0A45.2,45.2,0,0,0,153.41,12.06Z",
    style: {
      fill: "#ffce4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.84,25.42q2.47,2.28,4.7,4.68a74.84,74.84,0,0,1,14,21.19,45.79,45.79,0,0,0,1.4-6.43A52.38,52.38,0,0,0,181.3,7.22C175.74,10.61,171.7,17.38,170.84,25.42Z",
    style: {
      fill: "#f1b02e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "ad0aeefb-045a-4159-9ce5-f999bd2c1829",
    "data-name": "MUSTACHE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.43,110.32c-.15,1.7-6.51,2.53-14.2,1.86s-13.81-2.6-13.66-4.29,6.5-2.53,14.2-1.86S72.58,108.63,72.43,110.32Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,119.61c.15,1.69-6,3.62-13.66,4.29s-14.05-.16-14.19-1.86,6-3.61,13.66-4.29S72.9,117.91,73,119.61Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.86,107.49c.13,1.44,5.53,2.15,12.07,1.57s11.74-2.2,11.61-3.64-5.53-2.15-12.07-1.58S175.73,106.05,175.86,107.49Z",
    style: {
      fill: "#f1b02e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.86,114.85c-.13,1.45,5.07,3.08,11.61,3.65s11.94-.13,12.07-1.57-5.07-3.08-11.61-3.65S176,113.41,175.86,114.85Z",
    style: {
      fill: "#f1b02e"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSadCat);
export default __webpack_public_path__ + "static/media/IconSadCat.9b183157.svg";
export { ForwardRef as ReactComponent };